import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTelegramContext } from '@src/context/TelegramContext'

export const useTelegramInitParams = () => {
  const { WebApp } = useTelegramContext()
  const location = useLocation()

  const [raw] = React.useMemo(() => [WebApp.initData, location] as const, [WebApp.initData, location])
  const params = React.useMemo(() => {
    if (!raw) return new URLSearchParams()
    return new URLSearchParams(raw)
  }, [raw])

  return React.useMemo(() => ({ raw, params }), [raw, params])
}
